var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsKalender = function SvgLeonInmobiliariaIconsKalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-kalender_svg__st0{display:none}.leon-inmobiliaria-icons-kalender_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-kalender_svg__st1,.leon-inmobiliaria-icons-kalender_svg__st2{display:inline}.leon-inmobiliaria-icons-kalender_svg__st3{fill:currentcolor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-kalender_svg__Kalender"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Pfad_4983",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M10.7 15.2V86h79.7V15.2H10.7zm5.6 14.7v-9.2h68.6v9.2H16.3zm0 50.6v-45h68.6v45H16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1602",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M27.4 45.4h7v7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1603",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M27.4 63.6h7v7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1604",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M47.1 45.4h7v7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1605",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M47.1 63.6h7v7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1606",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M66.8 45.4h7v7h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-kalender_svg__Rechteck_1607",
    className: "leon-inmobiliaria-icons-kalender_svg__st3",
    d: "M66.8 63.6h7v7h-7z"
  }))));
};
export default SvgLeonInmobiliariaIconsKalender;